"use client";

import Image from "next/image";
import { Youtube } from "lucide-react";
import { DiscordMark } from "@/components/ui/discord-mark";
import { DISCORD_URL } from "@/lib/landing-constants";
import { cn } from "@/lib/utils";
import { phCapture } from "@/utils/analytics";

export const COMMUNITY_LINKS = [
  { platform: "discord", label: "Discord", href: DISCORD_URL },
  { platform: "youtube", label: "YouTube", href: "https://www.youtube.com/@UpsideTools" },
  { platform: "x", label: "X", href: "https://x.com/UpsideTools" },
] as const;

type Platform = (typeof COMMUNITY_LINKS)[number]["platform"];

export function trackCommunityLink(platform: Platform) {
  phCapture("community_link_clicked", { platform });
}

export function CommunityLinkIcon({ platform, className }: { platform: Platform; className?: string }) {
  switch (platform) {
    case "discord":
      return <DiscordMark className={cn(className, "opacity-70")} />;
    case "youtube":
      return <Youtube className={className} aria-hidden="true" />;
    case "x":
      return <Image src="/images/sportsbooks/x-logo.png" alt="" width={16} height={16} className={cn(className, "opacity-70")} />;
  }
}

export function CommunityLinks({ isMobile, className }: { isMobile: boolean; className?: string }) {
  return (
    <ul className={className}>
      {COMMUNITY_LINKS.map(({ platform, label, href }) => (
        <li key={platform}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackCommunityLink(platform)}
            className={cn(
              "flex items-center gap-2.5 rounded-md px-2.5 text-[13px] font-medium text-zinc-300 transition-colors hover:bg-white/[0.04] hover:text-zinc-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40",
              isMobile ? "h-11" : "h-8",
            )}
          >
            <CommunityLinkIcon platform={platform} className="size-4 shrink-0" />
            {label}
          </a>
        </li>
      ))}
    </ul>
  );
}
